import React from 'react';
import Payment from '../../../Images/pay.jpg';

const Pay = () => {
    return (
        <div className="text-center p-3">
            <h1>Payment Feature is Coming Soon</h1>
            <img className="img-fluid p-3" src={Payment} alt="" />
        </div>
    );
};

export default Pay;